import { useEffect } from "react";
import api from "../api/axios";

const WIDGET_HOST = "https://support.widget.devsoleil.com";

/**
 * Loads the Support Hub chat widget for the logged-in user.
 *
 * Fetches a server-signed identity from `/support-widget` (the Laravel API computes
 * HMAC(phone, sk_secret) — the secret never reaches the browser), sets
 * `window.HubWidgetConfig`, then injects the hosted widget script. The widget renders
 * inside a Shadow DOM, so it can't clash with the app's styles.
 *
 * Call once from an authenticated layout.
 */
export function useSupportWidget() {
  useEffect(() => {
    let cancelled = false;

    (async () => {
      if (!localStorage.getItem("access_token")) return;

      try {
        // NOTE: the axios response interceptor returns the response body directly,
        // so `data` here is already the payload object (not an axios response).
        const data = await api.get("/support-widget");
        if (cancelled || !data?.key) return;

        window.HubWidgetConfig = {
          product: data.product,
          key: data.key,
          name: data.name,
          email: data.email || undefined,
          external_id: data.external_id, // phone — the verified identifier
          user_hash: data.user_hash, // marks the session "verified"
        };

        if (!document.getElementById("hub-widget-js")) {
          const s = document.createElement("script");
          s.id = "hub-widget-js";
          s.src = `${WIDGET_HOST}/hub-widget.js`;
          s.async = true;
          document.body.appendChild(s);
        }
      } catch {
        // Non-fatal: the widget just won't load (e.g. offline, 403 origin, no secret yet).
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);
}

export default useSupportWidget;
